import type { AssessmentDomain } from './types'

// 設問・選択肢・判定ロジックは business-assessment.html のモックから1文字も変えずに移植している。
export const DOMAINS: AssessmentDomain[] = [
  {
    name: '顧客理解',
    desc: '顧客理解が個人の経験や感覚ではなく、組織資産として蓄積されている状態を指します。',
    points: [
      '顧客課題の収集方法が定義・標準化されているか',
      '顧客情報が組織内で共有・参照できるか',
      '新任メンバーでも顧客を理解できる状態か',
    ],
    questions: [
      {
        text: '顧客課題やニーズを把握するための情報収集方法が明確に定義されている',
        options: [
          '特定の方法は定義されておらず、担当者が各自で対応している',
          '一部のメンバーが独自に収集しているが、方法は個人任せ',
          '収集方法の合意はあるが、文書化・標準化されていない',
          '情報収集の手順が定義され、チームで共有されている',
          '収集方法が標準化され、PDCAで継続的に改善されている',
        ],
      },
      {
        text: '顧客インタビュー、営業・CSヒアリング、VOC確認などを定期的に行うルーティンがある',
        options: [
          '必要が生じたときだけ対応しており、定期的なルーティンはない',
          '一部メンバーが個人の判断で実施しているが、組織的ではない',
          '実施しているが頻度・担当が不定期で依存が強い',
          '定期スケジュールがあり、担当者が決まって実施している',
          '定例化され、アウトプットが施策に反映される仕組みがある',
        ],
      },
      {
        text: '顧客理解を整理するためのフォーマットやテンプレートが存在する',
        options: [
          'フォーマットは存在せず、各自が好きな形でまとめている',
          '過去に作られたものがあるが、現在は使われていない',
          '一部のチームや担当者が独自のフォーマットを使っている',
          '共通フォーマットがあり、チーム内で使われている',
          'フォーマットが整備され、継続的に更新・改善されている',
        ],
      },
      {
        text: '顧客情報が個人のメモや感覚ではなく、組織内で参照できる形で蓄積されている',
        options: [
          '顧客情報は個人のメモや頭の中にあり、組織的に蓄積されていない',
          '一部のメンバーが資料にまとめているが、共有されていない',
          '共有ドライブなどに保存されているが、参照しにくい状態',
          '整理された形で蓄積され、必要な人が参照できる',
          'ナレッジとして体系化され、定期的に更新される仕組みがある',
        ],
      },
      {
        text: '新任メンバーでも、主要顧客の課題や購買理由を理解できる状態になっている',
        options: [
          '新任メンバーは先輩から口頭で聞くしかない',
          '断片的な資料はあるが、体系的に学べる状態ではない',
          'オンボーディング資料があるが、顧客理解の内容は薄い',
          '顧客理解に関する資料が整備され、独力で学べる',
          '体系的な学習コンテンツがあり、短期間で実践レベルに達せる',
        ],
      },
    ],
    feedback: {
      A: '顧客理解が組織の仕組みとして高度に定着しています。継続的な改善で競争優位を維持できる状態です。',
      B: '顧客理解の基盤は整っています。情報収集の定例化と、組織全体への定着が次の課題です。',
      C: '一部では取り組みが見られますが、組織全体への展開が必要です。フォーマットの整備から始めましょう。',
      D: '顧客理解が個人の経験に依存しています。情報を組織で蓄積・共有する仕組みの構築が急務です。',
      E: '顧客理解の仕組みがほとんど整っていません。まずはヒアリングのルーティン化から始めましょう。',
    },
    training: ['顧客理解・インサイト設計研修', 'ペルソナ／カスタマージャーニー設計研修', 'VOC活用ワークショップ'],
    priorityDesc: '顧客理解が個人任せになっており、組織全体での施策精度向上につながりきっていない可能性があります。',
    priorityActions: ['顧客インタビュー設計の標準化', '顧客情報共有フォーマット整備', '定期VOCレビューの設定'],
  },
  {
    name: '競合理解',
    desc: '競争環境の変化を継続的に把握し、施策に反映できる状態を指します。',
    points: [
      '競合調査の頻度・対象・確認項目が定義されているか',
      '競合情報が組織で共有・施策反映されているか',
      '競争環境をチームで定期的に議論できているか',
    ],
    questions: [
      {
        text: '競合調査の対象範囲、調査頻度、確認項目が明確に定義されている',
        options: [
          '競合調査の定義がなく、必要な時に誰かが調べる状態',
          '調査する競合は決まっているが、頻度・項目は定まっていない',
          '一部のメンバーが独自に調査しているが、統一されていない',
          '調査対象・頻度・確認項目が定義され、チームに周知されている',
          '定義が文書化され、定期的に見直されている',
        ],
      },
      {
        text: '競合の訴求、価格、機能、事例、広告、コンテンツなどを定期的に確認する仕組みがある',
        options: [
          '競合情報の確認は属人的で、気づいたメンバーが都度共有する',
          '一部のメンバーが定期的に確認しているが、組織的ではない',
          '確認しているが記録や共有の仕組みがない',
          '定期的に確認し、チームに共有するルーティンがある',
          '競合変化をリアルタイムで把握し、施策に反映できる体制がある',
        ],
      },
      {
        text: '競合情報を整理するための共通フォーマットやテンプレートが存在する',
        options: [
          'フォーマットはなく、各自がバラバラに記録している',
          '過去に作られたが現在は使われていない',
          '一部が独自フォーマットを使っているが、統一されていない',
          '共通フォーマットが存在し、チームで活用している',
          'フォーマットが整備・更新され、比較分析に活用できる',
        ],
      },
      {
        text: '競合情報の変化が、マーケティング施策や営業資料に反映される流れがある',
        options: [
          '競合の変化が施策に反映される流れはない',
          '気づいたメンバーが個別に対応することはある',
          '情報は共有されるが、施策反映のプロセスが定まっていない',
          '競合変化に応じて施策・資料を見直すフローがある',
          '定期的に競合分析を施策レビューに組み込む仕組みがある',
        ],
      },
      {
        text: '競争環境の変化をチームで共有・議論する場が定期的にある',
        options: [
          '競合について話し合う場は存在しない',
          '必要な時だけ話し合うが、定期的ではない',
          '不定期だが競合の話をする機会はある',
          '定期的なミーティングで競合について共有している',
          '競合分析が戦略会議のアジェンダとして組み込まれている',
        ],
      },
    ],
    feedback: {
      A: '競合情報の収集・活用が組織として高度に定着しています。',
      B: '競合理解の基盤は整っています。情報を施策に反映するフローの強化が次の課題です。',
      C: '一部で取り組みが見られますが、組織全体への定着が必要です。',
      D: '競合調査が個人任せになっています。調査範囲・頻度・共有フローを定義することが重要です。',
      E: '競合情報の収集が仕組み化されていません。まず調査対象と頻度の定義から始めましょう。',
    },
    training: ['競合分析研修', '市場環境分析ワークショップ', 'ポジショニング設計研修'],
    priorityDesc: '競合情報の収集や共有が仕組み化されておらず、施策や訴求への反映が属人的になっている可能性があります。',
    priorityActions: ['競合調査フォーマットの整備', '競争環境レビューの定例化', 'ポジショニング整理ワークショップ'],
  },
  {
    name: '自社理解',
    desc: '自社の強みや訴求軸が言語化され、組織全体で共通認識になっている状態を指します。',
    points: [
      '強み・差別化ポイントが言語化・文書化されているか',
      '営業・マーケ・CSで訴求軸の共通認識があるか',
      '新任メンバーでも自社価値を説明できるか',
    ],
    questions: [
      {
        text: '自社サービスの強み、弱み、選ばれる理由が言語化されている',
        options: [
          '担当者によって説明が異なり、共通の言語がない',
          '断片的な資料はあるが、体系的にまとまっていない',
          '一部のドキュメントにまとめられているが、最新でない',
          '強み・弱み・選ばれる理由が文書化され共有されている',
          '定期的に見直され、組織全体で共通認識になっている',
        ],
      },
      {
        text: '営業、マーケティング、CSの間で、自社の提供価値や訴求軸に共通認識がある',
        options: [
          '部門ごとに異なる訴求をしており、一貫性がない',
          '大まかな方向性は共有されているが、詳細は部門任せ',
          '定期的に情報共有はあるが、共通認識とは言えない',
          '共通の訴求軸が定義され、部門間で認識が揃っている',
          '訴求軸が全部門に定着し、一貫したメッセージで顧客対応できる',
        ],
      },
      {
        text: 'ターゲット別、業界別、課題別に訴求メッセージが整理されている',
        options: [
          '訴求メッセージの整理は行われていない',
          '一部のターゲット向けに資料があるが、体系的でない',
          'いくつかのセグメントで整理されているが、不完全',
          '主要セグメントの訴求メッセージが整理されている',
          '網羅的に整理され、定期的に更新されている',
        ],
      },
      {
        text: '競合と比較した際の差別化ポイントが資料やドキュメントとして整備されている',
        options: [
          '差別化ポイントの資料は存在しない',
          '個人の認識はあるが、ドキュメント化されていない',
          '一部の営業資料に記載があるが、体系的でない',
          '差別化資料が整備され、営業・マーケで活用されている',
          '定期的に競合比較を行い、資料を最新化している',
        ],
      },
      {
        text: '新任メンバーでも、自社の価値や勝ち筋を説明できる状態になっている',
        options: [
          '新任メンバーが自社価値を説明できるようになるまで時間がかかる',
          'OJTで先輩から学ぶしかなく、品質にばらつきがある',
          '資料はあるが、説明できるレベルに達するには不十分',
          '資料とOJTの組み合わせで、早期に説明できるようになる',
          '体系的な学習プログラムで、短期間でバリューを伝えられるようになる',
        ],
      },
    ],
    feedback: {
      A: '自社の価値・差別化が組織の共通言語として高度に定着しています。',
      B: '自社理解の基盤は整っています。部門間での共通認識のさらなる強化が次の課題です。',
      C: '一部で言語化が進んでいますが、組織全体への展開が必要です。',
      D: '自社の価値・差別化が人によって異なる説明になっています。訴求軸の言語化を優先しましょう。',
      E: '自社の強みが言語化されていません。まず競合比較を通じた差別化ポイントの整理から始めましょう。',
    },
    training: ['自社価値言語化ワークショップ', '訴求設計研修', 'STP／ポジショニング研修'],
    priorityDesc: '自社の強みや差別化ポイントが組織共通言語になっておらず、訴求の一貫性に課題がある可能性があります。',
    priorityActions: ['自社価値の言語化・文書化', '訴求軸の組織共有', '差別化ポイント資料の整備'],
  },
  {
    name: '人材育成',
    desc: '育成が上長の個人スキルに依存せず、組織として再現できる状態を指します。',
    points: [
      '求めるスキル・役割が明文化されているか',
      'スキルマップ・育成計画が存在するか',
      '育成プロセスが標準化され、誰でも一定水準で育てられるか',
    ],
    questions: [
      {
        text: 'マーケティング人材に求めるスキルや役割が明文化されている',
        options: [
          '求めるスキルは明文化されておらず、上長の感覚で判断している',
          '大まかな期待値はあるが、文書化されていない',
          '一部の役職にはJDがあるが、全体的でない',
          'スキル要件と役割が文書化され、共有されている',
          '役割・レベル別に詳細なスキル定義が整備されている',
        ],
      },
      {
        text: 'メンバーのスキル状態を把握するための評価基準やスキルマップがある',
        options: [
          'メンバーのスキルは上長の主観で把握している',
          '定性的な評価はあるが、基準が不明確',
          '評価基準があるが、スキルマップとして可視化されていない',
          'スキルマップが存在し、定期的にアップデートされている',
          '個人のスキルが可視化され、育成計画に活用されている',
        ],
      },
      {
        text: 'メンバーごとの育成課題に応じた学習・育成計画が存在する',
        options: [
          '個人の育成計画は存在しない',
          '上長が個別に声をかけることはあるが、計画はない',
          '目標設定はあるが、育成計画とは言えない',
          '育成計画が作成され、定期的にレビューされている',
          '課題に応じた学習プログラムと計画が連動している',
        ],
      },
      {
        text: '上長がメンバーの成長課題を把握し、定期的にフィードバックする仕組みがある',
        options: [
          'フィードバックは偶発的で、仕組みとして存在しない',
          '半期評価時のみフィードバックがある',
          '1on1はあるが、育成に特化した内容ではない',
          '定期的に成長課題を確認し、フィードバックする場がある',
          'フィードバックの質と頻度が担保された仕組みが運用されている',
        ],
      },
      {
        text: '人が変わっても一定水準の育成ができるよう、育成プロセスが標準化されている',
        options: [
          '育成は上長の個人スキルに完全依存している',
          '優秀な上長がいる部門では育成されるが、ばらつきが大きい',
          '育成の型があるが、実施は上長任せ',
          '育成プロセスが標準化され、一定水準の育成ができる',
          'プロセスが継続的に改善され、育成品質が向上している',
        ],
      },
    ],
    feedback: {
      A: '人材育成の仕組みが組織として高度に定着しています。',
      B: '育成の基盤は整っています。スキルマップと育成計画の連動強化が次の課題です。',
      C: '一部で育成の取り組みが見られますが、標準化が必要です。',
      D: '育成が上長の個人スキルに依存しています。スキルマップの整備から始めましょう。',
      E: '育成の仕組みがほとんど整っていません。まず求めるスキル・役割の定義から始めましょう。',
    },
    training: ['マーケティング基礎／応用研修', 'マーケティングマネージャー育成研修', 'スキルマップ設計ワークショップ'],
    priorityDesc: '育成が上長や現場任せになっており、メンバーの成長スピードにばらつきが出ている可能性があります。',
    priorityActions: ['スキルマップの整備', '育成ロードマップの設計', 'マネージャー向け育成研修'],
  },
  {
    name: 'ナレッジ共有',
    desc: '成功・失敗の学びが組織に蓄積され、次の施策に活用できる状態を指します。',
    points: [
      '成功・失敗の施策が組織資産として蓄積されているか',
      '振り返りのフォーマット・会議体が整備されているか',
      'ナレッジが横展開され、次の施策に活用されているか',
    ],
    questions: [
      {
        text: '成功した施策の背景、プロセス、成果が再利用できる形で蓄積されている',
        options: [
          '成功事例は個人の記憶に留まり、組織に蓄積されない',
          '振り返り資料はあるが、再利用しやすい形でない',
          '成功事例は共有されるが、体系的に蓄積されていない',
          '施策の背景・プロセス・成果が整理されて蓄積されている',
          '事例ライブラリとして整備され、日常的に参照されている',
        ],
      },
      {
        text: '失敗した施策や学びも、組織内で共有される仕組みがある',
        options: [
          '失敗事例は共有されず、個人の経験で終わる',
          '失敗は語りにくい雰囲気があり、表に出ない',
          '稀に共有されることはあるが、仕組みではない',
          '失敗事例も共有する文化と場がある',
          '失敗からの学びが組織の資産として蓄積・活用されている',
        ],
      },
      {
        text: '施策後の振り返りを行うための共通フォーマットや会議体がある',
        options: [
          '施策後の振り返りは行われていない',
          '振り返りは各自に任されており、実施率が低い',
          'フォーマットはあるが、実施率が低い',
          '共通フォーマットと会議体があり、定期的に実施されている',
          '振り返りが習慣化され、アクションにつながっている',
        ],
      },
      {
        text: 'チームや担当者をまたいで、ナレッジを横展開する仕組みがある',
        options: [
          'ナレッジは各チーム内に留まり、横展開されない',
          '偶発的に共有されることはあるが、仕組みではない',
          '共有ドライブなどはあるが、積極的に活用されていない',
          '定期的な共有セッションや仕組みで横展開されている',
          'ナレッジの横展開が組織文化として定着している',
        ],
      },
      {
        text: '過去の施策や学びを、新しい施策設計に活用できる状態になっている',
        options: [
          '過去の施策情報にアクセスできず、毎回ゼロから考える',
          '情報はあるが、探すのが困難',
          '一部の情報は参照できるが、体系的でない',
          '過去施策の検索・参照ができ、設計に活用されている',
          '過去の学びが施策設計に自然に組み込まれている',
        ],
      },
    ],
    feedback: {
      A: 'ナレッジ管理が組織として高度に定着しています。',
      B: 'ナレッジ共有の基盤は整っています。失敗事例の共有とナレッジの横展開強化が次の課題です。',
      C: '一部で取り組みが見られますが、組織全体への定着が必要です。',
      D: '施策の学びが個人やチーム内に閉じています。まず振り返りフォーマットの標準化から始めましょう。',
      E: 'ナレッジ蓄積の仕組みがほとんど整っていません。最初の一歩として振り返り会を設定しましょう。',
    },
    training: ['施策振り返り設計ワークショップ', 'ナレッジマネジメント研修', 'マーケティングPDCA研修'],
    priorityDesc: '施策の学びが個人やチーム内に閉じており、成功パターンの横展開が進んでいない可能性があります。',
    priorityActions: ['振り返りフォーマットの整備', '事例共有会の定例化', 'ナレッジベースの構築'],
  },
  {
    name: 'AI活用',
    desc: 'AIが個人の工夫ではなく、業務プロセスに組み込まれている状態を指します。',
    points: [
      'AI活用方針・ガイドラインが定義されているか',
      '業務別のAI活用シーンが組織として整理されているか',
      'AI活用が業務プロセスに組み込まれているか',
    ],
    questions: [
      {
        text: 'マーケティング業務におけるAI活用方針やガイドラインが定義されている',
        options: [
          'AI活用に関する方針やルールが存在しない',
          '禁止事項は一部あるが、活用方針は定まっていない',
          '活用推奨ツールはあるが、方針として文書化されていない',
          'AI活用方針が定義され、チームに共有されている',
          '方針が整備され、継続的にアップデートされている',
        ],
      },
      {
        text: '業務で利用するAIツールや活用シーンが組織として整理されている',
        options: [
          '使用するAIツールは個人の判断に任されている',
          '一部のツールは周知されているが、活用シーンは整理されていない',
          '推奨ツールリストはあるが、活用シーンまでは整理されていない',
          '業務別の推奨ツールと活用シーンが整理されている',
          '活用シーン集が整備され、定期的に更新されている',
        ],
      },
      {
        text: 'AIを活用した業務効率化や施策改善の事例が組織内で共有されている',
        options: [
          'AI活用事例の共有が行われていない',
          '個人が成果を出しているが、組織には広がっていない',
          '稀に共有されることはあるが、仕組みではない',
          '定期的にAI活用事例を共有するセッションがある',
          '事例が蓄積・共有され、全員のAI活用レベルが向上している',
        ],
      },
      {
        text: 'AI活用が個人の工夫に留まらず、業務プロセスに組み込まれている',
        options: [
          'AI活用は一部の先進的なメンバーだけ',
          '関心のあるメンバーが個人的に活用している',
          'チームの一部では業務に活用しているが、全体ではない',
          '主要な業務プロセスにAI活用が組み込まれている',
          'AI前提の業務設計になっており、継続的に進化している',
        ],
      },
      {
        text: 'AIを前提に、マーケティング業務や人材育成のあり方を見直している',
        options: [
          'AIを前提とした業務設計の見直しは行われていない',
          '個別ツールの導入はあるが、業務設計の見直しではない',
          '一部の業務でAI前提の見直しが始まっている',
          '業務フロー全体をAIを前提に見直す取り組みがある',
          'AI前提での業務・育成の再設計が組織として進んでいる',
        ],
      },
    ],
    feedback: {
      A: 'AI活用が組織の業務プロセスに高度に定着しています。AI前提の組織設計が競争優位になっています。',
      B: 'AI活用の基盤は整っています。業務プロセスへの組み込みと横展開の強化が次の課題です。',
      C: '一部でAI活用が見られますが、組織全体への展開が必要です。活用方針の整備を優先しましょう。',
      D: 'AI活用が個人任せになっています。まず活用方針と推奨ツールの整理から始めましょう。',
      E: 'AI活用の仕組みがほとんど整っていません。まず活用方針の策定と研修実施から始めましょう。',
    },
    training: ['生成AI活用研修', 'マーケティング業務×AI活用ワークショップ', 'AIガイドライン設計支援'],
    priorityDesc: 'AI活用が個人任せになっており、組織全体の生産性向上につながりきっていない可能性があります。',
    priorityActions: ['AI活用方針の整理', '業務別AI活用パターンの設計', 'AI活用研修の実施'],
  },
]
